{
  "name": "clintplay-sdk",
  "version": "0.9.0",
  "description": "Clintplay - Session replay, error tracking, and automatic Playwright test generation",
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "import": {
        "types": "./dist/index.d.mts",
        "default": "./dist/index.mjs"
      },
      "require": {
        "types": "./dist/index.d.ts",
        "default": "./dist/index.js"
      }
    }
  },
  "files": [
    "dist"
  ],
  "repository": {
    "type": "git",
    "url": "https://github.com/clintdigital/clintplay",
    "directory": "packages/sdk"
  },
  "author": "ThreadCode",
  "homepage": "https://github.com/clintdigital/clintplay#readme",
  "scripts": {
    "build": "tsup",
    "verify:dist": "node scripts/verify-dist.mjs",
    "test": "vitest run",
    "test:watch": "vitest",
    "typecheck": "tsc --noEmit -p tsconfig.typecheck.json"
  },
  "keywords": [
    "session-replay",
    "error-tracking",
    "monitoring",
    "playwright",
    "rrweb"
  ],
  "license": "MIT",
  "packageManager": "pnpm@10.30.0",
  "dependencies": {
    "rrweb": "2.0.0-alpha.20"
  },
  "devDependencies": {
    "@sentry/browser": "~9.47.1",
    "@types/node": "^25.5.2",
    "jsdom": "^29.0.2",
    "tsup": "^8.5.1",
    "typescript": "^6.0.2",
    "vitest": "^4.1.3"
  }
}
